import { BaseModal } from './BaseModal'
import { StarIcon, UserGroupIcon } from '@heroicons/react/outline'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const NewFeaturesModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal
      title="🎉 Új funkciók!"
      isOpen={isOpen}
      handleClose={handleClose}
      preventBackdropClose={true}
      zIndex={1030}
    >
      <div className="text-gray-700 dark:text-gray-300">
        <p className="pb-4">Két izgalmas új funkcióval bővült a Szózat!</p>

        <div className="bg-indigo-50 dark:bg-indigo-800/30 rounded-lg p-4 mb-4">
          <div className="flex items-center gap-2 mb-2">
            <StarIcon className="h-6 w-6 text-yellow-500" />
            <h3 className="font-bold text-lg text-gray-900 dark:text-white">
              Heti bajnokság
            </h3>
          </div>
          <p className="text-sm">
            Mostantól hétről hétre versenyezhetsz másokkal! A napi feladványok
            megoldásáért pontokat kapsz, és a hét végén kiderül, ki a legjobb
            Szózat-játékos. Minél kevesebb próbálkozásból találod ki a szót,
            annál több pontot kapsz!
          </p>
        </div>

        <div className="bg-green-50 dark:bg-green-800/30 rounded-lg p-4 mb-4">
          <div className="flex items-center gap-2 mb-2">
            <UserGroupIcon className="h-6 w-6 text-green-500" />
            <h3 className="font-bold text-lg text-gray-900 dark:text-white">
              Privát szobák
            </h3>
          </div>
          <p className="text-sm">
            Hozz létre saját szobát a barátaidnak, családodnak vagy
            kollégáidnak! Minden szobának saját ranglistája van, így kiderülhet,
            ki a legjobb a csapatotokban. Meghívó linkkel könnyen
            csatlakozhattok egymáshoz.
          </p>
        </div>

        <div className="bg-amber-50 dark:bg-amber-800/30 rounded-lg p-4 mb-4">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-xl">⚠️</span>
            <h3 className="font-bold text-lg text-gray-900 dark:text-white">
              Fontos tudnivalók
            </h3>
          </div>
          <ul className="text-sm list-disc list-inside space-y-1">
            <li>
              Csak az <strong>aznapi feladvány</strong> számít bele a
              ranglistákba
            </li>
            <li>Random és egyedi feladványok nem befolyásolják a pontszámot</li>
            <li>
              A Statisztika menüben megadhatod a neved, ami megjelenik a
              ranglistán
            </li>
          </ul>
        </div>

        <button
          type="button"
          className="w-full mt-2 rounded-md border border-transparent shadow-sm px-4 py-3 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          onClick={handleClose}
        >
          Értem, játsszunk!
        </button>
      </div>
    </BaseModal>
  )
}
